import { IncCondDetail } from '@/common/entities/incCond/IncCondDetail';
import { IncCondList } from '@/common/entities/incCond/IncCondList';
import { IncDataSrcDetail } from '@/common/entities/incDataSrc/IncDataSrcDetail';
import { IncDataSrcList } from '@/common/entities/incDataSrc/IncDataSrcList';
import { IncListDetail } from '@/common/entities/incList/IncListDetail';
import { IncListList } from '@/common/entities/incList/IncListList';
import { IncRuleDetail } from '@/common/entities/incRule/IncRuleDetail';
import { IncRuleList } from '@/common/entities/incRule/IncRuleList';
import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { McdFinDashboard } from '@/sc/entities/mcdInv/dashboard/fin/McdFinDashboard';
import { McdInvDashboard } from '@/sc/entities/mcdInv/dashboard/inv/McdInvDashboard';
import { Route } from 'react-router-dom';
import { BestPriceDashboard } from './entities/bestPrice/dashboard/BestPriceDashboard';
import { DirSaleFinDashboard } from './entities/dirSale/dashboard/DirSaleFinDashboard';
import { DirSaleFinDashboard2 } from './entities/dirSale/dashboard/DirSaleFinDashboard2';
import { UcbInctvLedgerDashboard } from './entities/inctvLedgerDashboard/UcbInctvLedgerDashboard';
import { InctvRbtDashboard } from './entities/inctvRbt/dashboard/InctvRbtDashboard';
import { ChbkDashboard } from './entities/indirSale/dashboard/ChbkDashboard';
import { ChbkFinDashboard } from './entities/indirSale/finance/ChbkFinDashboard';
import { McdInvFinDashboard } from './entities/mcdInv/dashboard/fin/McdInvFinDashboard';
import { McdDispCLDList } from './entities/mcdUtilLine/McdDispCLDList';
import { McoFinDashboard } from './entities/mcoInv/dashboard/fin/McoFinDashboard';
import { McoInvDashboard } from './entities/mcoInv/dashboard/inv/McoInvDashboard';
import { FeesForecastPerspective } from './org/ucb/entities/dsaForecast/FeesForecastPerspective';

const scRoutes = [
  <Route path="/sc/dir-sale" element={<EntityView />} />,
  <Route path="/sc/dir-sale-line" element={<EntityView />} />,
  <Route path="/sc/dir-sale-fin-dashboard" element={<DirSaleFinDashboard />} />,
  <Route path="/sc/dir-sale-new-fin-dashboard" element={<DirSaleFinDashboard2 />} />,
  <Route path="/sc/indir-sale" element={<EntityView />} />,
  <Route path="/sc/filter" element={<EntityView />} />,
  <Route
    path="/sc/inc-data-src"
    element={<EntityView listComponent={IncDataSrcList} detailComponent={IncDataSrcDetail} />}
  />,
  <Route path="/sc/inc-rule" element={<EntityView listComponent={IncRuleList} detailComponent={IncRuleDetail} />} />,
  <Route path="/sc/inc-cond" element={<EntityView listComponent={IncCondList} detailComponent={IncCondDetail} />} />,
  <Route path="/sc/inc-list" element={<EntityView listComponent={IncListList} detailComponent={IncListDetail} />} />,
  <Route path="/sc/indir-sale" element={<EntityView />} />,
  <Route path="/sc/indir-sale-line" element={<EntityView />} />,
  <Route path="/sc/chbk-ledger" element={<EntityView />} />,
  <Route path="/sc/chbk-ledger-line" element={<EntityView />} />,
  <Route path="/sc/chbk-dashboard" element={<ChbkDashboard />} />,
  <Route path="/sc/chbk-fin-dashboard" element={<ChbkFinDashboard />} />,
  <Route path="/sc/mcd-util" element={<EntityView />} />,
  <Route path="/sc/mcd-util-line" element={<EntityView />} />,
  <Route path="/sc/mcd-disp-cld" element={<McdDispCLDList />} />,
  <Route path="/sc/mcd-ledger" element={<EntityView />} />,
  <Route path="/sc/mcd-ledger-line" element={<EntityView />} />,
  <Route path="/sc/mcd-disp" element={<EntityView />} />,
  <Route path="/sc/pymt/:domain" element={<EntityView />} />,
  <Route path="/sc/pymt" element={<EntityView />} />,
  <Route path="/sc/mcd-dashboard" element={<McdInvDashboard />} />,
  <Route path="/sc/mcd-inv-fin-dashboard" element={<McdInvFinDashboard />} />,
  <Route path="/sc/mcd-fin-dashboard" element={<McdFinDashboard />} />,
  <Route path="/sc/mcd-inv" element={<EntityView />} />,
  <Route path="/sc/mcd-rbt" element={<EntityView />} />,
  <Route path="/sc/mcd-inv-ledger-pymt" element={<EntityView />} />,
  <Route path="/sc/mcd-inv-date-tracker" element={<EntityView />} />,
  <Route path="/sc/mcd-inv-line" element={<EntityView />} />,
  <Route path="/sc/mcd-rbt-line" element={<EntityView />} />,
  <Route path="/sc/channel-data" element={<EntityView />} />,
  <Route path="/sc/adj" element={<EntityView />} />,
  <Route path="/sc/mco-inv" element={<EntityView />} />,
  <Route path="/sc/mco-inv-line" element={<EntityView />} />,
  <Route path="/sc/mco-inv-line-prog-prod" element={<EntityView />} />,
  <Route path="/sc/mco-rbt" element={<EntityView />} />,
  <Route path="/sc/mco-ledger" element={<EntityView />} />,
  <Route path="/sc/mco-ledger-line" element={<EntityView />} />,
  <Route path="/sc/mco-dashboard" element={<McoInvDashboard />} />,
  <Route path="/sc/mco-fin-dashboard" element={<McoFinDashboard />} />,
  <Route path="/sc/mco-rbt-line" element={<EntityView />} />,
  <Route path="/sc/inctv-rbt" element={<EntityView />} />,
  <Route path="/sc/inctv-rbt-dashboard" element={<InctvRbtDashboard />} />,
  <Route path="/sc/aes-best-price" element={<EntityView />} />,
  <Route path="/sc/best-price-dashboard" element={<BestPriceDashboard />} />,
  <Route path="/sc/inctv-rbt-line" element={<EntityView />} />,
  <Route path="/sc/inctv-ledger" element={<EntityView />} />,
  <Route path="/sc/inctv-ledger-line" element={<EntityView />} />,
  <Route path="/sc/inctv-rbt-ledger-pymt" element={<EntityView />} />,
  <Route path="/sc/acct-bal" element={<EntityView />} />,
  <Route path="/sc/mcd-inv-src" element={<EntityView />} />,
  <Route path="/sc/channel-data" element={<EntityView />} />,
  <Route path="/sc/mcd-pymt-master" element={<EntityView />} />,
  <Route path="/sc/dashboard/inctv-ledger" element={<UcbInctvLedgerDashboard />} />,
  <Route path="/sc/fees-forecast" element={<EntityView perspectiveComponent={FeesForecastPerspective} />} />,
];

export default scRoutes;
